import styled from 'styled-components';
import { breakpoints } from 'modules/v2/foundation/breakpoints';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet } from 'modules/v2/foundation/theme';
import { TableBodyCell } from '../TableCell';
import { TableRow } from '../TableRow/TableRow';
export const TableCollapseBodyCell = styled.td `
  padding: ${themeGet('spacing.sm')} ${themeGet('spacing.md')};

  ${breakpoints.sm} {
    ${(props) => `padding: ${themeGet('spacing.xl')} calc(${themeGet('spacing.2xl')} + ${pxToRem(props.$offset)});`}
  }
`;
export const StyledTableBodyCell = styled(TableBodyCell) `
  ${(props) => props.$hideOnBreakpoint && breakpoints[props.$hideOnBreakpoint]} {
    display: none;
  }
`;
export const TableCollapseRow = styled(TableRow) `
  ${(props) => props.$hideOnBreakpoint && breakpoints[props.$hideOnBreakpoint]} {
    display: none;
  }
`;
